<template>
    <GDialog
        v-model="modalStore.commentModal.show"
        max-width="500"
        border-radius="10"
        @update:model-value="hideModal"
    >
        <div class="comment-modal">
            <div class="modal-header">
                <div class="text-h3 text-bold text-center">
                    {{ headerTitle }}
                </div>
            </div>

            <div class="modal-body">
                <!-- View mode -->
                <div v-if="modalStore.commentModal.mode === 'view'" class="text-h4 pre-wrap">
                    {{ modalStore.commentModal.text }}
                </div>

                <!-- Create/Edit mode -->
                <textarea
                    v-else
                    v-model="localText"
                    class="comment-textarea text-h4"
                    placeholder="Введіть коментар"
                />
            </div>

            <div class="modal-buttons">
                <div class="container">
                    <!-- View mode controls -->
                    <template v-if="modalStore.commentModal.mode === 'view'">
                        <ButtonComponent
                            v-if="modalStore.commentModal.can_edit"
                            btn-style="gradient"
                            text="Редагувати"
                            @click="switchToEdit"
                        />
                        <ButtonComponent btn-style="grey" text="Закрити" @click="hideModal" />
                    </template>

                    <!-- Create/Edit mode controls -->
                    <template v-else>
                        <ButtonComponent btn-style="grey" text="Скасувати" @click="hideModal" />
                        <ButtonComponent
                            :disabled="!localText || submitting"
                            btn-style="gradient"
                            :text="submitting ? 'Збереження…' : 'Зберегти'"
                            @click="saveComment"
                        />
                    </template>
                </div>
            </div>
        </div>
    </GDialog>
</template>

<script>
import ButtonComponent from '@/components/ButtonComponent.vue'
import { useModalStore } from '@/stores/index.js'
import fetchWrapper from '@/helpers/fetch-wrapper.js'

export default {
    name: 'CommentModal',
    components: { ButtonComponent },
    setup() {
        const modalStore = useModalStore()

        return { modalStore }
    },
    data() {
        return {
            localText: '',
            submitting: false
        }
    },
    computed: {
        headerTitle() {
            const mode = this.modalStore.commentModal.mode

            if (mode === 'create') return 'Створити коментар'
            if (mode === 'edit') return 'Редагувати коментар'

            return 'Коментар'
        }
    },
    watch: {
        'modalStore.commentModal.show'(val) {
            if (val) {
                // initialize textarea when entering create/edit
                if (this.modalStore.commentModal.mode !== 'view') {
                    this.localText = this.modalStore.commentModal.text || ''
                }
            } else {
                this.localText = ''
            }
        }
    },
    methods: {
        hideModal() {
            this.modalStore.commentModal.show = false
            this.modalStore.commentModal.text = null
            this.modalStore.commentModal.mode = 'view'
            this.modalStore.commentModal.commentId = null
            this.modalStore.commentModal.entityId = null
            this.modalStore.commentModal.entityType = null
            this.modalStore.commentModal.can_edit = false
            this.modalStore.commentModal.onCreated = null
            this.modalStore.commentModal.onEdited = null
            this.modalStore.commentModal.onDeleted = null
            this.localText = ''
            this.submitting = false
        },
        switchToEdit() {
            this.modalStore.commentModal.mode = 'edit'
            this.localText = this.modalStore.commentModal.text || ''
        },
        async saveComment() {
            if (!this.localText) return

            this.submitting = true
            const { mode, entityId, entityType, commentId, onCreated, onEdited } =
                this.modalStore.commentModal

            try {
                if (mode === 'create') {
                    const resp = await fetchWrapper.post('comments/create', {
                        text: this.localText,
                        entity_id: entityId,
                        entity_type: entityType
                    })

                    onCreated && onCreated(resp)
                    this.$toast.success('Коментар створено')
                    this.hideModal()
                } else if (mode === 'edit' && commentId) {
                    const resp = await fetchWrapper.post(`comments/edit/${commentId}`, {
                        text: this.localText
                    })

                    onEdited && onEdited(resp)
                    this.$toast.success('Коментар оновлено')
                    this.hideModal()
                }
            } finally {
                this.submitting = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.comment-modal {
    padding: 2rem 0;

    .button-component {
        width: 100% !important;
    }
}

.comment-textarea {
    width: 100%;
    min-height: 8rem;
    padding: 0.75rem 1rem;
    border: 1px solid $grey-light;
    border-radius: 0.5rem;
    resize: vertical;
}

.pre-wrap {
    white-space: pre-wrap;
}

.modal-buttons .container {
    gap: 1rem;
}
</style>
